import React from 'react'
import { range } from 'ramda'
import ListItem from '../ListItem'
import { ListWrap, ListTitle, ListTags } from '../ListItem/styled'

const FakeLoaderListItem = ({ numberItems }) => {
    return (
        range(0, numberItems).map(item => (
            <ListItem active={false} to={{}} key={item}>
                <div>
                    <ListWrap>
                        <ListTitle loading />
                    </ListWrap>
                    <ListWrap>
                        <ListTags loading />
                    </ListWrap>
                </div>
            </ListItem>
        ))
    )
}

FakeLoaderListItem.defaultProps = {
    numberItems: 3
}

export default FakeLoaderListItem
